import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";

import Expert_Support_ from '../../../assets/Services/Unity_Game_Development/Features_of_Unity_Game_Development/Expert_Support_&_Unity_Know-How.svg'
import Fast_Prototyping from '../../../assets/Services/Unity_Game_Development/Features_of_Unity_Game_Development/Fast_Prototyping.svg'
import Impressive_Visuals from '../../../assets/Services/Unity_Game_Development/Features_of_Unity_Game_Development/Impressive_Visuals.svg'
import Multiplatform_Reach from '../../../assets/Services/Unity_Game_Development/Features_of_Unity_Game_Development/Multiplatform_Reach.svg'

import Access_to_Distinguished_Expertise from '../../../assets/Services/Unity_Game_Development/Unity_Game_Development_Process/Access_to_Distinguished_Expertise.svg'
import Advanced_Technology_Implementation from '../../../assets/Services/Unity_Game_Development/Unity_Game_Development_Process/Advanced_Technology_Implementation.svg'
import Complete_regional_adaptation from '../../../assets/Services/Unity_Game_Development/Unity_Game_Development_Process/Complete_regional_adaptation.svg'
import Expert_Consultation_on_Strategic_Issues from '../../../assets/Services/Unity_Game_Development/Unity_Game_Development_Process/Expert_Consultation_on_Strategic_Issues.svg'
import Pioneering_Game from '../../../assets/Services/Unity_Game_Development/Unity_Game_Development_Process/Pioneering_Game-play_Innovation.svg'

import Maskgroup  from '../../../assets/Services/Unity_Game_Development/Voice_of_Success_Our_Clients/Maskgroup-1.png'
import Maskgroup2  from '../../../assets/Services/Unity_Game_Development/Voice_of_Success_Our_Clients/Maskgroup-2.png'
import Maskgroup3  from '../../../assets/Services/Unity_Game_Development/Voice_of_Success_Our_Clients/Maskgroup.png'

import Arcade_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png'
import Bingo_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png'
import Board_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png'
import Ludo_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png'
import Poker_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Poker_Game_Development.png'
import Rummy_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png'

import Concept from '../../../assets/Services/Unity_Game_Development/img/Concept&Pre-production.png'
import Immersive_reality from '../../../assets/Services/Unity_Game_Development/img/Immersive_reality.png'
import Multiplayer from '../../../assets/Services/Unity_Game_Development/img/Multiplayer&online.png'
import Performance_optimization from '../../../assets/Services/Unity_Game_Development/img/Performance_optimization.png'
import Prototyping from '../../../assets/Services/Unity_Game_Development/img/Prototyping&rapid.png'
 
import Audio_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Audio_&_Sound.svg'
import Concept_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Concept_&_Validation.svg'
import Marketing_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Marketing_&_Launch.svg'
import Story_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Story_&_World-Building.svg'
import Systems_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Systems_&_Backend.svg'


import big from '../../../assets/Services/Game_page/Unity/big.png'
import icon from '../../../assets/Services/Game_page/Unity/one.png'
import icon2 from '../../../assets/Services/Game_page/Unity/two.png'
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";

const UnityGameDev = () => {
  const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const cards = [
    {
      title: "Concept & Pre-Production",
      desc: "We turn early ideas into real plans—world-building, character design, and mapping out how the game will actually play. It’s all about setting a strong foundation before we dive in.",
      img: Concept,
    },
    {
      title: " Prototyping & Rapid Iteration     ",
      desc: "   We build simple, playable test versions fast, so we can see what works and fix what doesn’t. This way, we make sure the game feels great before going all-in. ",
      img: Prototyping,
    },
    {
      title: "  Multiplayer & Online Services    ",
      desc: "   From co-op to competitive play, we design smooth, reliable online experiences. Our team focuses on stability, security, and low-latency performance, so multiplayer just works. ",
      img:Multiplayer ,
    },
    {
      title: " Performance Optimization   ",
      desc: " We meticulously profile and optimize every aspect of the game, ensuring it runs smoothly on a wide range of devices and platforms without compromising visual quality or player experience.   ",
      img: Performance_optimization,
    },
    {
      title: "Immersive Reality Experiences    ",
      desc: "   Our experts delve into the frontier of gaming, crafting captivating experiences in Virtual Reality (VR) and Augmented Reality (AR) that push the boundaries of immersion and interaction. ",
      img: Immersive_reality,
    },
  ];



  const pokerdevcompany = [
    {
      title: "  Concept & Validation",
      icon: Concept_,
      desc: "   Every project starts with a spark. We brainstorm creative ideas, test their market potential, and shape a clear vision to guide the team from day one.  ",
    },
    {
      title: "Story & World-Building ",
      icon: Story_,
      desc: " Next, we build the heart of the game: its world and story. Our writers develop rich lore, unique characters, and a narrative that draws players into something memorable.    ",
    },
    {
      title: "  Systems & Backend",
      icon: Systems_,
      desc: " Behind every great game is solid tech. Our engineers design reliable servers, smooth multiplayer systems, and robust data management—so everything just works.    ",
    },
    {
      title: " Audio & Sound ",
      icon: Audio_,
      desc: " Sound matters. Our audio team crafts original music and immersive effects, creating an atmosphere that brings every moment to life.    ",
    },
    {
      title: "  Marketing & Launch",
      icon: Marketing_,
      desc: " Finally, we make sure your game gets noticed. From strategic marketing plans to eye-catching promos, we handle everything needed for a successful release.    ",
    },
  ]

  const pokerdevcompany2 = [
    {
      title: "  Pioneering Game-play Innovation ",
      icon:Pioneering_Game ,
      desc: "Raiden prefers uniqueness in creativity when it comes to game design. We actively work to add interesting features and innovative mechanics. This dedication to uniqueness sets our product apart and improves the overall gaming experience, encouraging long-term user involvement.   ",
    },
    {
      title: "  Advanced Technology Implementation ",
      icon:Advanced_Technology_Implementation ,
      desc: " We take advantage of modern technological innovations, like safe digital asset management, innovative gaming capabilities, and dependable, scalable real-time infrastructure, to ensure peak performance and future adaptability.  ",
    },
    {
      title: "  Complete regional adaptation ",
      icon: Complete_regional_adaptation,
      desc: "Our approach combines subtle localization—regionally relevant payment methods, culturally sensitive design, and extensive multilingual support—to make sure your game has a significant impact on a wide range of international player communities.   ",
    },
    {
      title: "Expert Consultation on Strategic Issues   ",
      icon: Expert_Consultation_on_Strategic_Issues,
      desc: "As the project progresses from conception to market launch, we offer crucial strategic direction. Our skilled consultants make sure your project complies with current industry norms and is positioned to optimize its competitiveness.   ",
    },
    {
      title: "  Access to Distinguished Expertise ",
      icon:Access_to_Distinguished_Expertise ,
      desc: "Our professionals can produce a polished, reliable, and market-ready unity game with accuracy and efficiency because they have a wealth of knowledge and specialized skills.   ",
    },
  ];

  const gamedevservices = [
    {
      title: "Arcade Game Development",
      icon: Arcade_Game_Development,
      desc: " Design adrenaline-charged arcade experiences with fast-paced gameplay, eye-catching visuals, and high replayability—optimized for both mobile and web platforms.",
      link: "/arcade-game-development",
    },
    {
      title: "Poker  Game Development  ",
      icon: Poker_Game_Development,
      desc: " Our poker platforms feature secure, scalable game logic, support for multiple variants, and tournament systems. We implement advanced encryption for transactions and provide intuitive user interfaces for optimal player experience.",
      link: "/poker-game-development",
    },
    {
      title: "Bingo Game Development",
      icon: Bingo_Game_Development,
      desc: " Reimagine bingo digitally with dynamic formats like 75-ball, 90-ball, and speed bingo. Enrich the experience with real-time chat, leaderboards, social features, and scalable server infrastructure.",
      link: "/bingo-game-development",
    },
    {
      title: " Board Game Development",
      icon: Board_Game_Development,
      desc: " Bring timeless board games like Ludo, Chess, and Monopoly to digital life with intuitive interfaces, real-time multiplayer capabilities, and socially engaging mechanics.",
      link: "/board-game-development",
    },
    {
      title: "Ludo Game Development",
      icon: Ludo_Game_Development,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: " Rummy Game Development",
      icon:Rummy_Game_Development ,
      desc: " Develop scalable and secure Rummy solutions that offer smooth gameplay and high-performance backend support.",
      link: "/rummy-game-development",
    },
  ];

  const custom = [
    {
      icon: Fast_Prototyping,
      title: "Fast Prototyping  ",
      desc: "Have an idea? We’ll turn it into a playable prototype in no time. You get to see and test your game early, so you can give feedback and shape how it turns out. No wasted effort—just a smarter, quicker path to the game you want.",
    },
    {
      icon:Expert_Support_ ,
      title: "  Expert Support & Unity Know-How ",
      desc: " Don’t worry about the tech details. Our Unity specialists handle coding, bug fixes, and performance, so you can keep your focus on your vision. We make sure your game runs smoothly and reliably.  ",
    },
    {
      icon:Multiplatform_Reach ,
      title: "   Multiplatform Reach  ",
      desc: "Build once, play anywhere. Your game will work on PC, consoles, and mobile—all from the same project. This saves time and money, and means you can reach more players without extra hassle.   ",
    },
    {
      icon:Impressive_Visuals ,
      title: "Impressive Visuals   ",
      desc: " Your game should look great. We use Unity’s advanced rendering tools to create visuals that stand out, whether you’re after realism or a unique style. Players will notice—and keep coming back.  ",
    },
  ];

  const technologies = [
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  Frontend",
      desc: "Swift",
      desc2: " Flutter",
      desc3: " React Native",
    },

    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: " Backend ",
      desc: " Node.js",
      desc2: " Python",
      desc3: " .NET Core",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "Databases  ",
      desc: "PostgreSQL ",
      desc2: " MongoDB",
      desc3: " Firebase",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "Cloud & Hosting  ",
      desc: " AWS",
      desc2: " Google Cloud",
      desc3: " Azure",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  APIs & Integrations",
      desc: " GraphQL",
      desc2: " SOAP",
      desc3: "Twilio ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: " Testing Tools ",
      desc: " Appium",
      desc2: " Selenium",
      desc3: " Anti-Fraud System",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "DevOps & CI/CD  ",
      desc: " GitLab CI/CD",
      desc2: " Jenkins",
      desc3: " Docker",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  Analytics & Monitoring",
      desc: " Google Analytics",
      desc2: " Firebase Analytics",
      desc3: " Sentry",
    },
  ];

  const card = [
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "mobile",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "PC ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "TABLET ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "CONSOLE",
    },
  ];

  const clientexp = [
    {
      icon: Maskgroup,
      name: "Ethan Blackwood",

      desc: "Raiden Labs exceeded all our expectations. From the very beginning, they were able to quickly translate our vision into a tangible, playable experience. The team's deep knowledge of Unity's capabilities allowed us to launch a visually stunning game on multiple platforms seamlessly. Their professionalism and consistent support made the entire development process a smooth and rewarding journey.",
    },
    {
      icon: Maskgroup3,
      name: "Anya Petrova ",
      undername: " ",
      desc: "Choosing Raiden Labs was the best decision we made. Their team's ability to rapidly prototype our game gave us so much confidence, and their expertise in multiplatform development meant we could reach a wider audience than we ever thought possible. The final product was not only delivered on time but also looked absolutely incredible, thanks to their mastery of Unity's powerful rendering features. They are true professionals",
    },
    {
      icon: Maskgroup2,
      name: " Marcus Thorne",
      undername: "  ",
      desc: "Raiden Labs was a game-changer for our project. They took our concept from an idea to a stunning, playable prototype in record time, and their Unity expertise ensured our game launched flawlessly across both PC and mobile. The quality of the visuals they delivered was breathtaking, and their team was a pleasure to work with. We couldn't have asked for a better partner to bring our vision to life..",
    },
  ];
  const handleClick=(e)=>{
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    console.log("data subitted successfully")
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container  marb " style={{ minHeight: "100vh" }}>
        <div className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin"      style={{ minHeight: "100vh"}}  >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">Unity Game Development</h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              At Raiden Labs, Unity is our playground. We build interactive
              experiences that look great and run smoothly—no shortcuts. As your
              Unity game development partner, we’re all about turning your ideas
              into real, playable games that stand out. Let’s create games people genuinely love to play.
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a Quote
              </button>
            </Link>
          </div>
         <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className=" col-lg-6 text-center mb-3">
            <img src={big} style={{ width: "85%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Our Unity Development Commitment
            </h2>
            <p className="mt-4  h1-para" >
              At Raiden Labs, we build unforgettable interactive experiences
              powered by Unity. Our team has over ten years of experience and is
              adept at making original, top-notch games for the web, mobile
              devices, and PCs.We uphold transparency and integrity, giving you complete control over your code and clear visibility at every stage. With our technology, your game can stand out rather
              than blend in. Ingenious design that keeps players interested and
              technology that works. We also don't hesitate to impart our
              industry knowledge; instead of just giving you catchphrases, you
              will get real strategy.
            </p>
            <ul className="mt-3 h1-para">
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Player ownership of in-game assets.
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Verifiable digital assets and smart contracts.
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Full-cycle, bespoke game creation.
              </li>
            </ul>
            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base ">
          Our Unity Game Development Services
        </h2>
        <p className="mt-2 h1-para ">
          {" "}
          Raiden Labs prides itself on utilizing the latest tools and frameworks
          to ensure our games are not only beautiful and fun but also stable,
          secure, and future-proof.
        </p>
        <CoreSlider cards={cards} />
      </div>

      <div className="mt-80  text-center bg-light pt-50 pb-50 mart">
        <div className="container">
          <h2 className="text-center lh-base  mb-3 h2-heading ">
            Features of Unity Game Development
          </h2>
          <p className="mb-4 pb-2 text-center mx-lg-4">
            Unity Game Development with Raiden Labs – Simple & Professional
          </p>
          <CoreComponent31 custom={custom} />
          <Link to="/request-quote">
            <button className="py-2 px-4 mx-auto h1-para btn-gradient rounded-3 text-white mt-3">
              Buy online poker software
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                Integrate Unity to sense and engage with your vision game.
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                Raiden Labs' cutting-edge, high-performance Unreal game
                development produces an engaging gaming experience that embraces
                not just your devices but also your reality.{" "}
              </p>
              <Link to="/request-quote">
                <button className="py-2 mt-4 px-4 h1-para mx-auto mx-lg-0 btn-gradient rounded-3 text-white ">
                  TALK WITH OUR EXPERTS NOW!
                </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={icon} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
            The Raiden Edge: Advanced Tech and a Flawless Unity
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
            Raiden Labs integrates a skilled tech stack that supports compliance
            to create a distinctive and cutting-edge Unity  gameplay  experience.
          </p>
          <CoreComponent32  />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal Unity: Seamless Across Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
              Raiden Labs platform's real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your Unity app stays stable and usable, boosting user
              engagement on all platforms
            </p>

            <CoreComponent37  />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row">
            <div className="col-lg-6 my-auto ">
              <h2 className="h2-heading lh-base mb-2 fs-3 text-white mb-lg-3">
                Secure Your Digital World
              </h2>
              <p
                className="h1-para text-white  lh-base"
                style={{ opacity: 0.6 }}
              >
                Protect your business from threats. Our security specialists
                provide robust solutions to safeguard your data and fortify your
                infrastructure, giving you peace of mind.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={icon2} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

     <div className="container mt-80 ">
        <h2 className="text-center lh-base h2-heading ">
          Experience Raiden’s Unity Game Development
        </h2>
        <p className="h1-para my-3 fs-6 mx-lg-4  text-center">
          We are able to translate complicated concepts into dependable, useful
          frameworks for understanding technical and  industry-specific demands.
          Our comprehensive understanding benefits customers by ensuring
          reliable and effective solutions.{" "}
        </p>

        <CoreComponent36 pokerdevcompany={pokerdevcompany2} />
      </div>

      <div className="container mt-80 text-center ">
        <h2 className="h2-heading lh-base ">Explore our other games</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We specialize in developing immersive and feature-rich games tailored
          for both casual and competitive players. Our expertise ensures secure,
          fair, and scalable platforms with real-time multiplayer functionality.
          With stunning visuals and intuitive gameplay, our games keep users
          engaged and coming back for more.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      


       <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base mb-3">
          Our Unity Game Development Process
        </h2>
        <p className="lh-base mb-3 pb-2 h1-para">
          Our process focuses on transforming an initial concept into a finished
          product, building a compelling world and story while engineering the
          underlying technology, and finalizing the experience with
          comprehensive audio and a strategic launch plan.
        </p>
        <div>
          <CoreComponent35 pokerdevcompany={pokerdevcompany} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
          Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 pb-2 h1-para">
          Hear directly from those who've partnered with us. These testimonials
          reflect Raiden Labs' commitment to excellence, innovation, and client
          satisfaction in  Unity game creation.
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
{/* <FaqHome/> */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default UnityGameDev;
